import { render } from "./RedLineButton.vue?vue&type=template&id=39642207&scoped=true"
import script from "./RedLineButton.vue?vue&type=script&lang=js"
export * from "./RedLineButton.vue?vue&type=script&lang=js"

import "./RedLineButton.vue?vue&type=style&index=0&id=39642207&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39642207"]])

export default __exports__